import { AnnouncementModal } from '@vt/vt-ui';
import React from 'react';

const EddDialog = ({ open, onCancel, onSubmit, title, message, type, edd_status }) => {

  const submitLabel = {
    'pending': 'Verify',
    'rejected': 'Verify',
    'terminated': 'OK'
  }

  const cancelLabel = {
    'pending': 'Not Now ',
    'rejected': 'Not Now ',
    'terminated': 'Cancel'
  }
  
  return (
    <div>
      <AnnouncementModal
        title={title}
        content={message}
        open={open}
        onCancel={onCancel}
        onSubmit={onSubmit}
        variant={type}
        submitLabel={submitLabel[edd_status]}
        cancelLabel={edd_status === 'terminated' ? false : cancelLabel[edd_status]}
      />
    </div>
  );
};

export default EddDialog;
